/* One capturing group wrapping the whole alternation, every inner group
   non-capturing: String.split then returns [text, token, text, token, ...],
   so odd indices are the tokens. */
const TOKEN =
  /("(?:\\u[\da-fA-F]{4}|\\[^u]|[^\\"])*"(?:\s*:)?|\b(?:true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/;

function tokenClass(t: string): string {
  if (t.startsWith('"')) return t.trimEnd().endsWith(":") ? "j-key" : "j-str";
  if (t === "true" || t === "false") return "j-bool";
  if (t === "null") return "j-null";
  return "j-num";
}

/** Pretty-prints a value with per-token colouring.
 *
 *  Tokens become React elements, never markup strings: report bodies carry
 *  customer-supplied names, addresses and free-text suspicion details, so
 *  dangerouslySetInnerHTML is not an option here. */
export function JsonView({ value }: { value: unknown }) {
  const text = JSON.stringify(value, null, 2) ?? "";
  // Colouring allocates a React element and a DOM span per token (~231 per
  // transaction). A 500-transaction candidate would be ~115k spans, so past
  // this point the report stays pretty-printed but renders as one text node.
  if (text.length > 150_000) return <pre className="json-view">{text}</pre>;
  return (
    <pre className="json-view">
      {text.split(TOKEN).map((part, i) =>
        part === "" ? null : (
          <span key={i} className={i % 2 === 1 ? tokenClass(part) : "j-punc"}>
            {part}
          </span>
        ),
      )}
    </pre>
  );
}
